<template>
  <div>

    <v-card-title style="border-radius: 15px;" class="BoldBuilderGradient justify-start mediumoverline">
        <v-avatar size="80" class="mx-1">
             <v-img contain src="@/assets/BnPFullLogo.png"/>
        </v-avatar>
      Social Network Config
      </v-card-title>
       <v-card elevation="0" class="siteconfigcard"  v-if="QuickEditSections.length > 0">
        <v-card-subtitle class="mediumoverline">
          Default Routes
      </v-card-subtitle>
      <v-card-subtitle v-if="SystemInstance.Social_Landing_Page">
        <v-btn @click="AddSocialPageandLanding()">Add Page</v-btn>
      </v-card-subtitle>
      <v-card-text >
          <QuickEditComponent :System="System" :SystemEntities="SystemEntities" :Record="SystemInstance" :QuickEditSections="QuickEditSections"
            @UpdateContentEditableField="UpdateContentEditableField" @UploadFileSelect="UploadFileSelect" @SelectImage="SelectImage"
            @AddGallerySubcolImages="AddGallerySubcolImages"
            />
      </v-card-text>
      <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn @click="UpdateQuickEdits()" dark color="success">
              Save
          </v-btn>
      </v-card-actions>
      </v-card>
      <v-card elevation="0" class="siteconfigcard" v-if="!ActiveTemplate">
        <v-card-subtitle class="mediumoverline">
          Moderators
      </v-card-subtitle>
      <v-card-text>
          <ModeratorsConfig :System="System" :SystemEntities="SystemEntities"
          :SiteModerators="SiteModerators"
          />
    </v-card-text>
      <v-card-actions>
          <v-spacer>
          </v-spacer>
          <v-btn dark color="success">
              Save
          </v-btn>
      </v-card-actions>
      </v-card>
      <v-card elevation="0" class="siteconfigcard" v-if="!ActiveTemplate">
        <v-card-subtitle class="mediumoverline">
          Recent Activity
      </v-card-subtitle>
      <v-card-text >
         Per Module
      </v-card-text>
      </v-card>
      
  </div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import InfoSheet from '@/components/WebPages/RenderComponents/InfoSheetReadOnly';
import ModeratorsConfig from '@/components/SuiteBuilder/Main/ModeratorsConfig'
import QuickEditComponent from '@/components/Database/QuickEditComponent'
export default {
    props: ['System','SystemEntities','SiteModerators','ActiveTemplate'],
    components: {InfoSheet,ModeratorsConfig,QuickEditComponent},
    data() {
        return {
            TemplateCategoryFixes: [
                {Fieldid: 'Group_Categories',ArrayName: 'GroupsCategories'},
                {Fieldid: 'Forum_Categories',ArrayName: 'ForumsCategories'}
            ],
            GroupsCategories: [],
            ForumsCategories: [],
            SystemTickets: [],
            RoadmapItems: [],
            SystemInstance: '',
            elmnt:  {	
                						
                RowColor: '#00ffff',									
                Name: 'Info Sheet',									
                ShowComponents: true,									
                Icon: 'mdi-alert',									
                Title: 'About',									
                Description: `Add the Ability to import Platform Features`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                Color: 'red',	
                Elevation: 6,
                AlertIcon: 'mdi-alert',	
                BorderPosition: 'top',
                ColoredBorder: true,							
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:3,									
                FlexLarge: 3,									
                FlexMedium: 4,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,	
                Progress: 0,
                // Prominent: true								
            },	
        }
    },	
    computed:{
        ActiveSuiteTemplate(){
            return this.$store.state.ActiveSuiteTemplate
        },
        MarketplaceTemplates(){
        return this.SuiteTemplateView ? this.ActiveSuiteTemplate.templates : this.MyMarketplaceTemplates.concat(this.OtherMarketplaceTemplates)
        },
        OtherMarketplaceTemplates(){
            return []
            //just not allowed for "suites"
        },
        MyMarketplaceTemplates(){
        return this.$store.state.MyMarketplaceTemplates
        },
        CurrentEntityFields(){
            //console.log('SystemConfigEntity',this.SystemConfigEntity)
            return this.SystemConfigEntity.AllFields.map(field => {
                let fieldobj = Object.assign({},field)
                let match = this.TemplateCategoryFixes.find(obj => obj.Fieldid === field.id)
                if(this.ActiveTemplate && match){
                    if(!this.ActiveTemplate.CategoryFields){
                        this.ActiveTemplate.CategoryFields = []
                    }
                    let tempfield = this.ActiveTemplate.CategoryFields.find(obj => obj.id === fieldobj.id)
                    if(tempfield){
                        fieldobj = tempfield
                        fieldobj.Options = this[match.ArrayName]
                    }
                    else{
                        fieldobj.lastassignedinteger = 1000000
                        fieldobj.Options = this[match.ArrayName]
                    }
                }
                //then only "missing fix" being when we store, we should store these categories in a subcol, why stuff around right?
                //So these values assign ConfigPath through UpdateQuickEdits function
                return fieldobj
            })
            // we canot obejct assign or else things like lastassignedinterger on dyn options et wn't work, keep reassigning to previous
            //what we will do it call the field value, so i changes are canclled, reset to stored value of system, or systme entity alike. yeah..I think. yes 
            //okay sure so we modify state, but reassign abck to system props, and like when we alter dynamic option sets, we alter the field..should be okay?
            //.map(field => {
            //     let fieldobj = Object.assign({},field)
            //     return fieldobj
            // })
        },
        SystemConfigEntity(){
            return this.$store.state.SystemConfigEntity
        },
        QuickEditSections(){
            //we have Guest_Default_Page and Guests_Default_Page have to decide
          let sect1fields = this.ActiveTemplate ? ['Social_Module_Name'] : ['Social_Landing_Page','Social_Module_Name']
          let sect2fields = ['Guests_can_Social','Guest_Landing_Page','Social_Content_for_Guests','Disable_Guest_Posts']
          let sect3fields = ['Site_Articles_Public','Site_Blogs_Public','Site_Events_Public','Site_Meetups_Public']
          let sect4fields = ['Forum_Categories']
            let sect6fields = ['Group_Categories']
            //this directories need to atually start looking if any is active but yeah
            let quicklists = [
                {Name: 'Classifieds',Pluginid: 'Classifieds',Path: '/DirectoryBuilder/Classifieds'},
                {Name: 'Groups',Pluginid: 'Group_Directories',Path: '/DirectoryBuilder/Group_Categories'},
                {Name: 'Featured Members',Pluginid: 'Featured_Members',Path: '/DirectoryBuilder/Featured_Members'},
                {Name: 'Sites',Pluginid: 'Web_App_Builder',Path: '/DirectoryBuilder/Systems'},
                ].filter(item => {
                    return this.PluginDataBase[item.Pluginid] && this.PluginDataBase[item.Pluginid].Active
                })
            if(this.ActiveTemplate){
                quicklists = quicklists.map(item => {
                    item.Path = this.ActiveSuiteTemplate  ? '/Your-Domain/'+this.ActiveTemplate.id+item.Path : '/MarketplaceTemplate/'+this.ActiveTemplate.id+item.Path
                    return item
                })
            }
                //need quicklists but everything for that matter must check plugins. and groups here, is not site groups plugin but group direcotries plugin
          return [
            {Header: 'General',Type: 'Fields',Fields: this.PrepQuickFieldSection(sect1fields),Class: 'flex xl6 lg6 md6 sm12 xs12'},
            {Header: 'Guests',Type: 'Fields',Fields: this.PrepQuickFieldSection(sect2fields),Class: 'flex xl6 lg6 md6 sm12 xs12'},
            {Header: 'Public',Type: 'Fields',Fields: this.PrepQuickFieldSection(sect3fields),Class: 'flex xl4 lg4 md4 sm6 xs12'},
            {Header: 'Directories',Type: 'QuickList',QuickLists: quicklists,Class: 'flex xl8 lg8 md8 sm6 xs12'},
            //Reall for ActiveTepmlate logic we should basically manipulate CurrentEntityFields "Forum_Categories" and propogate it with the "Options" from "ForumsCategories"
             {Header: 'Forums',Type: 'Fields',Fields: this.PrepQuickFieldSection(sect4fields),Class: 'flex xl6 lg6 md6 sm12 xs12'},
             {Header: 'Group Categories',Type: 'Fields',Fields: this.PrepQuickFieldSection(sect6fields),Class: 'flex xl6 lg6 md6 sm12 xs12'},
          ]
        },
        QuickEditFieldObjects(){
            return this.QuickEditSections.filter(sect => {
                return sect.Fields
            }).map(sect => {
                return sect.Fields
            }).flat()
        },
        QuickEditFields(){
            return this.QuickEditFieldObjects.map(field => {
                    return field.id
                })
        },
        AppsDataBase(){
            return this.$store.state.AppsDataBase
        },
        NonGuestUsers(){
            return this.$store.state.UsersArray.filter(user => {
                return !user.IsGuestUser
            })
        },
        PluginDataBase(){
            return this.ActiveTemplate ? this.ActiveTemplate.PluginDataBase : this.$store.state.PluginDataBase
        },
        Has_Public_Signup(){
         return this.PluginDataBase && this.PluginDataBase.Public_Signup ? this.PluginDataBase.Public_Signup.Active : false
       },
        WebsiteisActive(){
            return this.$store.state.WebsiteisActive
        },
        SocialNetworkisActive(){
            return this.$store.state.SocialNetworkisActive
        },
        DatabaseisActive(){
            return this.$store.state.DatabaseisActive
        },
        DocumentationisActive(){
            return this.$store.state.DocumentationisActive
        },
         ActiveDB(){
            return db
        },
        IncompleteRoadmapItems(){
            return this.RoadmapItems.filter(item => {
                return item.Status && item.Status.Name !== 'InActive'
            })
        },
        OpenSystemTickets(){
            return this.SystemTickets.filter(ticket => {
                return ticket.Status && ticket.Status.Name !== 'InActive'
            })
        },
        HighlightedAlertElements(){
            let items = [
                {Title: 'Incomplete System Tickets',Array: 'OpenSystemTickets', TableName: 'System Tickets', TablePath: 'SystemTickets',IncompleteName: 'Open'},
                {Title: 'Incomplete Roadmap Items',Array: 'IncompleteRoadmapItems', TableName: 'Roadmap Items', TablePath: 'Roadmap',IncompleteName: 'Incompleted'},
            ]
            items.map(item => {
               if(this[item.Array] && this[item.Array].length > 0){
                        item.Description = 'You have a total of '+this[item.Array].length+' '+item.IncompleteName+' '+item.TableName+'. View them now?'
                        item.Color = 'red'
                        item.AlertIcon = 'mdi-alert'
                        item.HasActionButton = true
                        item.RoutePath = '/'+item.TablePath
                    }
                    else if(!this[item.Array] || this[item.Array] && this[item.Array].length === 0){
                        item.Description = 'No '+item.TableName+' '+item.IncompleteName+'.'
                        item.Color = 'green'
                        item.AlertIcon = 'mdi-check'
                    }
                return item
            })
            return items.map(item => {
                let elmnt = Object.assign({},this.elmnt)
                elmnt.Title = item.Title
                elmnt.Description = item.Description
                elmnt.Color = item.Color
                elmnt.AlertIcon = item.AlertIcon
                if(item.HasActionButton){
                    elmnt.HasActionButton = item.HasActionButton
                    elmnt.RoutePath = item.RoutePath
                }
                return elmnt
            })
        },
        userLoggedIn () {
        return this.$store.getters.user
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
        ConfigPath(){
            return this.ActiveTemplate ? db.collection('marketplacetemplates').doc(this.ActiveTemplate.id) : db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID)
        }
    },
    watch: {
        System: {
            handler: function(newvalue, oldvalue) {
             //console.log(oldvalue, newvalue,'this.$store.state',this.$store.state)
                if(newvalue !== oldvalue && newvalue && newvalue.id && !this.ActiveTemplate){
                     this.SystemInstance = this.System
                }
            },deep: true
        },
        ActiveTemplate: {
            handler: function(newvalue, oldvalue) {
             //console.log(oldvalue, newvalue,'this.$store.state',this.$store.state)
                if(newvalue !== oldvalue && newvalue && newvalue.id){
                     this.SystemInstance = this.ActiveTemplate.TemplateProps
                }
            },deep: true
        }, 
        SocialItemInteractMethod(v){   
        let acceptedmethods = ['UpdateSocialDefaultLandingPage']   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){
        if(this.ActiveTemplate){
            this.SystemInstance = this.ActiveSuiteTemplate ? this.ActiveTemplate : this.ActiveTemplate.TemplateProps
            //This may become the new standard entire suite level cause updating system props is triggering too many things downstream.
            this.GetSiteForumsCategories()
            let tempmatch = this.MarketplaceTemplates.find(obj => obj.id === this.ActiveTemplate.id)
           // console.log('this.ActiveTemplate.CategoryFields',this.ActiveTemplate.CategoryFields,this.MarketplaceTemplates,'tempmatch',tempmatch)
            
        //console.log('this.ActiveTemplate.Assets',this.ActiveTemplate.Assets)
        }
        else{
            this.SystemInstance = this.System
        }
    },
    methods:{
        GetSiteForumsCategories(){
        this.ConfigPath.collection('ForumsCategories').onSnapshot(res => {
            const changes = res.docChanges();
              changes.forEach(change => {
                if (change.type === 'added') {
                  this.ForumsCategories.push({
                    ...change.doc.data(),
                    id: change.doc.id
                  })
                }
              })
          })
      },
        AssignSocialItemInteractMethod(item,SecondProp){
        //console.log('AssignSocialItemInteractMethod',item,SecondProp)
        this.$store.commit('SetSocialItemInteractMethodProp','') 
        this.$store.commit('SetSocialItemInteractMethod','')
        if(SecondProp){
            this.$store.commit('SetSocialItemInteractMethodProp',SecondProp) 
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        else if(item){
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        },
        UpdateSocialDefaultLandingPage(route){
            let updobj = {}
            
            if(this.ActiveTemplate){
                updobj = {...this.ActiveTemplate.TemplateProps,Social_Landing_Page: route}
                this.ConfigPath.update({
                    TemplateProps: updobj}).then(updatedsysobj => {
                    this.AssignSocialItemInteractMethod('DeactivateNewPageDialog')
                    this.$router.push(route)
                }) 
            }
            else{
                updobj = {Social_Landing_Page: route}
             //console.log('seems to')
            this.ConfigPath.update(updobj).then(updatedsysobj => {
                this.AssignSocialItemInteractMethod('DeactivateNewPageDialog')
                this.$router.push(route)
            })    
            }
            
        },
        AddSocialPageandLanding(){
            this.$store.commit('SetRandomInteractProp','Default Social Landing Page')
            this.AssignSocialItemInteractMethod('ToggleNewPageDialog','Members Only')
        },
        PrepQuickFieldSection(fields){
        return fields.map(field => {
            let fieldobj = this.CurrentEntityFields.find(obj => obj.id === field)
            //console.log(field,fieldobj,this.System)
            if(fieldobj.Type === 'Date' && typeof fieldobj.DateMenu === 'undefined'){
              fieldobj.DateMenu = false
              if(typeof this.SystemInstance[fieldobj.Name] !== 'undefined' && typeof this.SystemInstance[fieldobj.Name].toDate !== 'undefined'){
                let dateobject = this.SystemInstance[fieldobj.Name].toDate()
                this.SystemInstance[fieldobj.Name] = format(dateobject,'yyyy-MM-dd')
              }
            }
            if(fieldobj.Type === 'Calculated Field'){
              this.SystemInstance[fieldobj.Name] = this.PerformedCalculation(this.SystemInstance,fieldobj)
            }
            if(fieldobj.Type === 'Option Set' && fieldobj.IsDynamic && typeof this.SystemInstance[fieldobj.Name] !== 'undefined'){
                //console.log(this.System[fieldobj.Name])
                fieldobj = JSON.parse(JSON.stringify(this.SystemInstance[fieldobj.Name]))
            }
            return fieldobj
          })
      },
        UpdateContentEditableField(prop,value,AdditionalSaveMethod,FieldObject){
      FieldObject[prop] = value
      if(AdditionalSaveMethod){
        this[AdditionalSaveMethod]()
      }
    },
        
        UpdateQuickEdits(){
            let values = this.QuickEditFields
            let updobj = {}
            if(this.ActiveTemplate){
                updobj = {...this.ActiveTemplate.TemplateProps}
            }
            values.map(val => {
                if(typeof this.SystemInstance[val] !== 'undefined'){
                    updobj[val] = this.SystemInstance[val]
                }
            })
            if(this.ActiveTemplate){
                //EXCEPTIONS!
                //console.log(updobj,this.SystemInstance,this.QuickEditFields,this.QuickEditSections,this.QuickEditFieldObjects)
                let Categories = [

                ]
                this.TemplateCategoryFixes.map(field => {
                    let fieldobj = Object.assign({},field)
                    let entfield = this.QuickEditFieldObjects.find(obj => obj.id === fieldobj.Fieldid)
                    //console.log('entfield',entfield)
                    fieldobj.Entries = entfield.Options
                    Categories.push(fieldobj)
                    delete updobj[field.Fieldid]
                })
                console.log(Categories)
             this.ConfigPath.update({
                TemplateProps: updobj
                }).then(updatedsysobj => {
                    Categories.map(cat => {
                        console.log(cat)
                        cat.Entries.map(opt => {
                        this.ConfigPath.collection(cat.ArrayName).doc(opt.ID.toString()).set(opt).then(addeddoc => {
                        })
                        let fieldobj = Object.assign({},this.QuickEditFieldObjects.find(obj => obj.id === cat.Fieldid))
                        delete fieldobj.Options
                        //fieldobj.lastassignedinteger = 1000000+cat.Entries.length
                        //console.log(fieldobj)
                        this.ConfigPath.collection('CategoryFields').doc(fieldobj.id).set(fieldobj).then(setfielddoc => {
                        })
                        })
                    })
            })
            }
            else{
               this.ConfigPath.update(updobj).then(updatedsysobj => {

            }) 
            }        
        },
        UpdateAllowNotificaitonDisable(){
            let updobj = {}
            if(this.ActiveTemplate){
            updobj = {...this.ActiveTemplate.TemplateProps,Allow_Notification_Disable: this.SystemInstance.Allow_Notification_Disable}
            this.ConfigPath.update({
               TemplateProps: updobj
            })
            }
            else{
                updobj = {Allow_Notification_Disable: this.SystemInstance.Allow_Notification_Disable}
                this.ConfigPath.update(updobj)
            }
        },  
        NoPathFilterRoutePass(route){
        let routernonroutes = ['404','PasswordReset','UserInvite','ExpiredLink','404','landingpagesingle','PermissionError','login']
        //SiteEventSocialSingle and sarrticles etc excluded from route.meta.type Social
        let mainnonroutes = ['FeaturedMember','BusinessMember','SiteMemberSingle','SitePostSingle','noticesingle','ClassifiedSingle','ClassifiedEnquiry',
        'GroupArticle','GroupMeetup','GroupDashboard','GroupBlog','GroupForum','GroupPage','GroupPoll','GroupSingle','GroupEdit','GroupPageEditor','GroupNewPoll','GroupNewArticle','GroupNewMeetup','GroupNewBlog',
        'GroupNewPoll','GroupWebFormEditor','GroupWebFormBuilder','GroupPageBuilder',
        'LinkedInAuth','TeamMemberActivities','DashboardBuilder','PipelineManagement','PageEditor','newbannerad','newlandingpage','noticenew','MyActivitiesbyType','MyTeamMemberActivities',
        'TableViewer','EntryViewer','WebFormEditor','SurveyBuilder','DirectoryBuilder','PDFExportFunctionBuilder','WikiCollectionBuilder','DataImport','SystemTrainingDocument','FeaturedMemberEdit',
        'CustomDashboard'
        ]
        if(!routernonroutes.includes(route.name) && !mainnonroutes.includes(route.name)){
         return !route.meta || route.meta && route.meta.RouteEventID !== 1028 && route.meta.RouteEventID !== 1027 && route.meta.TopicCategory !== 'Social Page' &&
         route.meta.type !== 'Social' && route.meta.type !== 'Classified Listing Viewer' && route.meta.type !== 'Wiki Editor' && route.meta.type !== 'Wiki Viewer'
         && !route.meta.DataSingleBuilder && !route.meta.ClassifiedListingBuilder 
        }
        else{
          return false
        }        
      },
        RouteOptions(field){
            let routes = this.$router.getRoutes()
            return routes.filter(route => {
                if(field.PathFilter){
                    if(field.PathFilter === 'None'){
                    return this.NoPathFilterRoutePass(route)
                    }
                    else if(field.PathFilter === 'Non Guest Routes'){
                    return route.name === 'MyDashboard' || route.name === 'MyProfile' || route.name === 'Home' || route.meta && route.meta.RouteEventID === 1027 || route.meta && route.meta.TopicCategory === 'Social Page'
                    }
                    else if(field.PathFilter === 'Guest Routes'){
                      //we had this.System.Guests_can_Social && route.meta && route.meta.RouteEventID === 1027 but then typically "store" page not allowed
                    return route.name === 'MyAccount' || route.meta && route.meta.RouteEventID === 1027 || this.SystemInstance.Guests_can_Social && route.meta &&  route.meta.TopicCategory === 'Social Page'
                    }
                    else if(field.PathFilter === 'Public Pages'){
                        return route.meta && route.meta.RouteEventID === 1028
                    }
                    else if(field.PathFilter === 'Internal Pages'){
                      return route.meta && route.meta.RouteEventID === 1027 || route.meta && route.meta.TopicCategory === 'Social Page'
                    }
                }                
                else{
                    return route
                }
            })
        },
        GetArrayData(query,array){
            query.onSnapshot(res => {
                const changes = res.docChanges();
                changes.forEach(change => {
                    if (change.type === 'added') {
                    let recordobj = {
                        ...change.doc.data(),
                        id: change.doc.id
                    }
                    if(array === 'GroupLandingPageViews'){                        
                        recordobj.Page_Obj = {
                            id: recordobj.Path.split('/')[3].split(' ').join('_'),
                            Page_Name: recordobj.Path.split('/')[3]
                        }
                        recordobj.Group_Obj = {
                            id: recordobj.RecordId,
                            Group_Name: recordobj.RecordId.split('_').join(' ')
                        }
                        //console.log('GroupLandingPageViews',recordobj)
                    }
                    if(array === 'PublicPageViews' || array === 'SocialPageViews'){
                        recordobj.Page_Obj = {
                            id: recordobj.RecordId,
                            Page_Name: recordobj.RecordId.split('_').join(' ')
                        }
                        if(recordobj.User && recordobj.Userid){
                            recordobj.User_Obj = {
                                Full_Name: recordobj.User,
                                id: recordobj.Userid
                            }
                        }
                    }
                    if(array === 'LandingPageViews'){
                        recordobj.Page_Obj = {
                            id: recordobj.RecordId,
                            Page_Name: recordobj.RecordId.split('_').join('')
                        }
                        if(recordobj.User && recordobj.Userid){
                            recordobj.User_Obj = {
                                Full_Name: recordobj.User,
                                id: recordobj.Userid
                            }
                        }
                    }
                    this[array].push(recordobj)
                }
                })
            })
        },
    }
}
</script>

<style>

</style>



